module.exports = __webpack_public_path__ + "img/lateral-esquerda.2354cc7f.webp";